__turbopack_context__.v({
  "container": "KzBo0a_container",
  "content": "KzBo0a_content",
  "description": "KzBo0a_description",
  "image": "KzBo0a_image",
  "imageWrap": "KzBo0a_imageWrap",
  "item": "KzBo0a_item",
  "name": "KzBo0a_name",
});
